import { jsx as h } from "react/jsx-runtime";
import { useMemo as l } from "react";
import { useAuth as T } from "@dcentralexpedientedigital/fe-shared/hooks/use-auth";
import { isPlatformApiErrorResponse as I } from "../shared/errors/error-keys.js";
import { readJsonResponse as P } from "../shared/http/read-json-response.js";
import { PlatformApiContext as b } from "./create-provider.js";
const w = ({ baseUrl: e, path: o, params: t }) => {
  const r = new URL(o, e);
  if (t)
    for (const [c, n] of Object.entries(t))
      n !== void 0 && r.searchParams.set(c, String(n));
  return r.toString();
}, U = async (e) => {
  try {
    const o = await e.json();
    if (I(o)) {
      const t = typeof o.error.statusCode == "number" ? o.error.statusCode : e.status;
      return {
        ...o,
        error: {
          ...o.error,
          statusCode: t,
          message: o.error.message ?? e.statusText ?? "Unknown error"
        }
      };
    }
  } catch {
  }
  return {
    error: {
      code: `HTTP-${e.status}`,
      statusCode: e.status,
      message: e.statusText || "Unknown error"
    },
    requestId: ""
  };
}, m = async ({
  baseUrl: e,
  method: o,
  path: t,
  token: r,
  tenantId: c,
  options: n
}) => {
  const { params: d, body: i, hasIdempotencyKey: a, ...s } = n ?? {}, p = w({ baseUrl: e, path: t, params: d }), y = Object.fromEntries(new Headers(s.headers).entries()), f = {
    "Content-Type": "application/json",
    "X-Tenant-ID": c,
    ...r ? { Authorization: `Bearer ${r}` } : {},
    ...a ? { "Idempotency-Key": crypto.randomUUID() } : {},
    ...y
  }, u = await fetch(p, {
    method: o,
    ...s,
    headers: f,
    body: i ? JSON.stringify(i) : void 0
  });
  if (!u.ok)
    throw await U(u);
  return P(u);
}, j = ({
  children: e,
  config: o
}) => {
  var i;
  const { baseUrl: t, tenantId: r } = o, { auth: c } = T(), n = ((i = c == null ? void 0 : c.user) == null ? void 0 : i.access_token) ?? null, d = l(
    () => ({
      get: (a, s) => m({ baseUrl: t, method: "GET", path: a, token: n, tenantId: r, options: s }),
      post: (a, s) => m({
        baseUrl: t,
        method: "POST",
        path: a,
        token: n,
        tenantId: r,
        options: { ...s, hasIdempotencyKey: !0 }
      }),
      put: (a, s) => m({
        baseUrl: t,
        method: "PUT",
        path: a,
        token: n,
        tenantId: r,
        options: { ...s, hasIdempotencyKey: !0 }
      }),
      patch: (a, s) => m({
        baseUrl: t,
        method: "PATCH",
        path: a,
        token: n,
        tenantId: r,
        options: { ...s, hasIdempotencyKey: !0 }
      }),
      delete: (a, s) => m({
        baseUrl: t,
        method: "DELETE",
        path: a,
        token: n,
        tenantId: r,
        options: { ...s, hasIdempotencyKey: !0 }
      })
    }),
    [t, n, r]
  );
  return /* @__PURE__ */ h(b.Provider, { value: d, children: e });
};
export {
  j as PlatformApiProvider
};
